import _ from "lodash";
import React, { useState, useEffect } from "react";

import { Button, Modal, Tooltip } from "@toddle-edu/ds-web";
import { OpenBookStarOutlined } from "@toddle-edu/ds-icons";

import { connect } from "react-redux";

import SuggestedPrompts from "./components/SuggestedPrompts";
import SuggestedPromptsSidebar from "./components/SuggestedPromptsSidebar";

import ConditionalWrapper from "Utils/ConditionalWrapper";

import classes from "./PromptSuggestionModal.scss";

const styles = {
  bodyStyle: {
    padding: "0",
    overflow: "hidden",
  },
  modalHeaderStyle: {
    padding: "12px 16px",
  },
  modalFooterStyle: {
    padding: "16px",
  },
};

const PromptSuggestionModal = React.memo(props => {
  const {
    t,
    displayPrompts,
    userPrompts,
    onPromptSuggestionModalClose,
    initialGroupType,
    onPromptSelection,
    isAIResponseLoading,
    language,
    resolvedSubjectGroupNodes,
  } = props;

  const [selectedPrompt, setSelectedPrompt] = useState({});
  const [selectedPromptCategory, setSelectedPromptCategory] = useState(
    initialGroupType || _.first(displayPrompts)?.groupType
  );

  useEffect(() => {
    setSelectedPrompt({});
  }, [selectedPromptCategory]);

  const filteredPrompts = _.filter(
    userPrompts,
    ({ groupType }) => groupType === selectedPromptCategory
  );

  const onSelectedPromptChange = prompt => {
    setSelectedPrompt(prompt);
  };

  const onSelectedPromptCategoryChange = promptCategory => {
    setSelectedPromptCategory(promptCategory);
  };

  const onUsePromptClick = () => {
    onPromptSelection(selectedPrompt);
    onPromptSuggestionModalClose();
  };

  return (
    <Modal width="1072px" height="656px" onClose={onPromptSuggestionModalClose}>
      <Modal.Header hasSeparator={true} style={styles.modalHeaderStyle}>
        <div className={classes.headerContainer}>
          <div className={classes.headerLeft}>
            <div className={classes.iconWrapper}>
              <OpenBookStarOutlined variant="link" />
            </div>
            {t("common:suggestion_library")}
          </div>
        </div>
      </Modal.Header>
      <Modal.Body style={styles.bodyStyle}>
        <div className={classes.bodyContainer}>
          <SuggestedPromptsSidebar
            t={t}
            displayPrompts={displayPrompts}
            selectedPromptCategory={selectedPromptCategory}
            language={language}
            onSelectedPromptCategoryChange={onSelectedPromptCategoryChange}
          />
          <SuggestedPrompts
            t={t}
            prompts={filteredPrompts}
            selectedPrompt={selectedPrompt}
            language={language}
            onSelectedPromptChange={onSelectedPromptChange}
            resolvedSubjectGroupNodes={resolvedSubjectGroupNodes}
          />
        </div>
      </Modal.Body>
      <Modal.Footer hasSeparator={true} style={styles.modalFooterStyle}>
        <div className={classes.footerContainer}>
          <Button
            variant="outlined-subtle"
            size="medium"
            onClick={onPromptSuggestionModalClose}
            testId={
              "worksheet-worksheetAssistant-PromptSuggestionModal-closePromptSuggestionModal"
            }
          >
            {t("common:cancel")}
          </Button>

          <ConditionalWrapper
            type={"wrapperAsElement"}
            condition={isAIResponseLoading}
            wrapper={
              <Tooltip
                placement={"left"}
                tooltip={t("classRoom:prompt_generate_button_disable_text")}
              />
            }
          >
            <Button
              variant="progressive"
              size="medium"
              disabled={_.isEmpty(selectedPrompt) || isAIResponseLoading}
              onClick={onUsePromptClick}
              testId={
                "worksheet-worksheetAssistant-PromptSuggestionModal-generate"
              }
            >
              {t("common:generate")}
            </Button>
          </ConditionalWrapper>
        </div>
      </Modal.Footer>
    </Modal>
  );
});

PromptSuggestionModal.displayName = "PromptSuggestionModal";

const mapStateToProps = (state, ownProps) => {
  const { constantPrompts: prompts } = ownProps;

  const displayPrompts = _.filter(
    prompts,
    ({ promptType }) => promptType === "display"
  );
  const userPrompts = _.filter(
    prompts,
    ({ promptType }) => promptType === "user"
  );

  return {
    isData: true,
    isLoading: false,
    userPrompts: _.sortBy(userPrompts, "displaySequence"),
    displayPrompts: _.sortBy(displayPrompts, "displaySequence"),
  };
};

export default connect(mapStateToProps, null)(PromptSuggestionModal);
